import React from "react";
import { Box, Tab, Tabs, TextField } from "@mui/material";
import WalletSelect from "../input/WalletSelect";
import CategorySelect from "../input/CategorySelect";
import BudgetSelect from "../input/BudgetSelect";
import BalanceNumericFormat from "../utils/BalanceNumericFormat";
import {useTranslation} from "react-i18next";

export const TransactionTypeTabs = ({ type, onChange, ariaLabel }) => {
    const {t} = useTranslation();
    return (
        <Box sx={{ borderBottom: 1, borderColor: "divider", marginBottom: 4 }}>
            <Tabs value={type} onChange={(_, newValue) => onChange(newValue)} aria-label={ariaLabel} variant="fullWidth">
                <Tab label={t("common.transactionType.expense")} value="EXPENSE" />
                <Tab label={t("common.transactionType.income")} value="INCOME" />
                <Tab label={t("common.transactionType.transfer")} value="TRANSFER" />
            </Tabs>
        </Box>
    );
};

export const TransactionDetailsFields = ({
    type,
    walletFromId,
    walletToId,
    categoryToId,
    categoryFromId,
    budgetId,
    amountValue,
    transferAmountFromValue,
    transferAmountToValue,
    description,
    onWalletFromChange,
    onWalletToChange,
    onCategoryToChange,
    onCategoryFromChange,
    onBudgetChange,
    onAmountChange,
    onTransferAmountFromChange,
    onTransferAmountToChange,
    onDescriptionChange,
    sameTransferCurrency,
    fieldErrors = {},
    hideDescription = false,
    hideBudget = false
}) => {
    const {t} = useTranslation();


    return (
        <>
            <Box sx={{ m: 2 }}>
                {(type === "EXPENSE" || type === "TRANSFER") && (
                    <WalletSelect
                        selectedWalletId={walletFromId}
                        width="48%"
                        label={t("common.labels.walletFrom")}
                        onChange={onWalletFromChange}
                        error={!!fieldErrors.walletFrom}
                        helperText={fieldErrors.walletFrom}
                    />
                )}
                {type === "EXPENSE" && (
                    <CategorySelect
                        categoryType="EXPENSE"
                        sx={{ marginLeft: "12px" }}
                        width="48%"
                        selectedCategoryId={categoryToId}
                        label={t("common.labels.categoryTo")}
                        onChange={onCategoryToChange}
                        error={!!fieldErrors.categoryTo}
                        helperText={fieldErrors.categoryTo}
                    />
                )}
                {type === "INCOME" && (
                    <CategorySelect
                        categoryType="INCOME"
                        width="48%"
                        selectedCategoryId={categoryFromId}
                        label={t("common.labels.categoryFrom")}
                        onChange={onCategoryFromChange}
                        error={!!fieldErrors.categoryFrom}
                        helperText={fieldErrors.categoryFrom}
                    />
                )}
                {(type === "INCOME" || type === "TRANSFER") && (
                    <WalletSelect
                        selectedWalletId={walletToId}
                        sx={{ marginLeft: "12px" }}
                        width="48%"
                        label={t("common.labels.walletTo")}
                        onChange={onWalletToChange}
                        error={!!fieldErrors.walletTo}
                        helperText={fieldErrors.walletTo}
                    />
                )}
            </Box>
            <Box sx={{ m: 2 }}>
                {type === "TRANSFER" && !sameTransferCurrency ? (
                    <>
                        <TextField
                            label={t("common.labels.amountFrom")}
                            variant="standard"
                            sx={{ width: "48%" }}
                            value={transferAmountFromValue}
                            onChange={(event) => onTransferAmountFromChange(event.target.value)}
                            error={!!fieldErrors.amountFrom}
                            helperText={fieldErrors.amountFrom}
                            InputProps={{
                                inputComponent: BalanceNumericFormat,
                            }}
                        />
                        <TextField
                            label={t("common.labels.amountTo")}
                            variant="standard"
                            sx={{ width: "48%", marginLeft: "12px" }}
                            value={transferAmountToValue}
                            onChange={(event) => onTransferAmountToChange(event.target.value)}
                            error={!!fieldErrors.amountTo}
                            helperText={fieldErrors.amountTo}
                            InputProps={{
                                inputComponent: BalanceNumericFormat,
                            }}
                        />
                    </>
                ) : (
                    <>
                        <TextField
                            label={t("common.labels.amount")}
                            variant="standard"
                            sx={{ width: "48%" }}
                            value={amountValue}
                            onChange={(event) => onAmountChange(event.target.value)}
                            error={!!fieldErrors.amount}
                            helperText={fieldErrors.amount}
                            InputProps={{
                                inputComponent: BalanceNumericFormat,
                            }}
                        />
                        {type === "EXPENSE" && !hideBudget && (
                            <BudgetSelect
                                selectedBudgetId={budgetId}
                                sx={{ marginLeft: "12px" }}
                                width="48%"
                                label={t("common.labels.budget")}
                                onChange={onBudgetChange}
                                error={!!fieldErrors.budget}
                                helperText={fieldErrors.budget}
                            />
                        )}
                    </>
                )}
            </Box>
            {!hideDescription && (
                <Box sx={{ m: 2 }}>
                    <TextField
                        id="description"
                        multiline
                        maxRows={4}
                        minRows={2}
                        value={description}
                        onChange={(e) => onDescriptionChange(e.target.value)}
                        label={t("common.labels.description")}
                        variant="standard"
                        fullWidth
                        error={!!fieldErrors.description}
                        helperText={fieldErrors.description}
                    />
                </Box>
            )}
        </>
    );
};
